import React, {useEffect} from 'react';
import ScheduleIcon from '@material-ui/icons/Schedule';
import PropTypes from 'prop-types';
import moment from "moment-timezone";

import {
  makeStyles,
  TableRow,
  TableCell,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from "@material-ui/core";
import CustomSwitch from "../../../../Common/CustomSwitch";
import t from "../../../../../languages/pl";

const styles = makeStyles({
  tableCell: {
    border: 0,
    paddingBottom: '8px',
  },
  formControlWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "start"
  },
  formControl: {
    marginLeft: "16px",
  }

});

const PrivateWorkingHoursRow = props => {
  const {displayName, isSwitch, individualWorkType, time, onSwitchChange, onTimeChange, disabled} = props;
  const classes = styles();
  const hourArray = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
  const minArray = [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55];

  const [hour, setHour] = React.useState("0");

  const [minutes, setMinutes] = React.useState("0");

  useEffect(() => {
    const ut = moment.unix(time);
    const h = moment(ut).hour();
    const m = moment(ut).minute();
    setHour(h);
    setMinutes(m);
  }, [time])


  const handleHourChange = (event) => {

    setHour(event.target.value);
    const ut = moment.unix(time);
    let m = moment(ut);
    m.set({hour: event.target.value})
    onTimeChange(m);
  };

  const handleMinutesChange = (event) => {

    setHour(event.target.value);
    const ut = moment.unix(time);
    let m = moment(ut);
    m.set({minutes: event.target.value})
    onTimeChange(m);
  };


  return (
    <TableRow>
      <TableCell className={classes.tableCell}>
        <Typography variant="body1">
          {displayName}:
        </Typography>
      </TableCell>
      <TableCell className={classes.tableCell} align={'right'}>
        {isSwitch
          ?
          <CustomSwitch
            color="primary"
            checked={individualWorkType}
            onChange={() => onSwitchChange(!individualWorkType)}
          />
          :
          <div className={classes.formControlWrapper}>
            <ScheduleIcon/>

            <FormControl fullWidth className={classes.formControl}>
              <InputLabel id="individual-hours-label">{t.hour}</InputLabel>
              <Select
                labelId="individual-hours-label"
                id="individual-hours-select"
                value={hour}
                label={t.hour}
                onChange={handleHourChange}
                disabled={disabled}
              >
                {
                  hourArray.map((hour) =>
                    <MenuItem key={hour} value={hour}>{hour}</MenuItem>)
                }
              </Select>
            </FormControl>

            <FormControl fullWidth className={classes.formControl}>
              <InputLabel id="individual-minutes-label">{t.min}</InputLabel>
              <Select
                labelId="individual-minutes-label"
                id="individual-minutes-select"
                value={minutes}
                label={t.min}
                onChange={handleMinutesChange}
                disabled={disabled}
              >
                {
                  minArray.map((min) =>
                    <MenuItem key={min} value={min}>{min}</MenuItem>)
                }
              </Select>
            </FormControl>

          </div>
        }
      </TableCell>
    </TableRow>
  );
};

PrivateWorkingHoursRow.propTypes = {
  displayName: PropTypes.string,
  isSwitch: PropTypes.bool,
  individualWorkType: PropTypes.bool,
  time: PropTypes.number,
  onSwitchChange: PropTypes.func,
  onTimeChange: PropTypes.func,
  disabled: PropTypes.bool,
};

export default PrivateWorkingHoursRow;
